import { render } from "./ProposalSummary.vue?vue&type=template&id=ebaa71d6&scoped=true"
import script from "./ProposalSummary.vue?vue&type=script&lang=js"
export * from "./ProposalSummary.vue?vue&type=script&lang=js"

import "./ProposalSummary.vue?vue&type=style&index=0&id=ebaa71d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebaa71d6"]])

export default __exports__